module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/43Hxix/tc-custom/9781507176740.jpg?1677500044389",
      "alt": "This image is the cover for the book The Institute"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Institute\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Professor Salvatierra, a professor at the University of Madrid, receives a strange letter from his friend Professor Reimann, director of a prestigious research institute in Duseldorf, in which he asks him to visit him since there are some internal plots and schemes going on at the Institute, and he needs Salvatierra's help. Salvatierra and his partner Cristina, a former student of his, take advantage of the summer to travel to Duseldorf and, shortly afterwards, Reimann disappears without a trace. Police link the disappearance to the murder of a small Turkish drug dealer. Salvatierra and Cristina, between the distrust of the German police and the harassment of a gang of criminals, are discovering the surprising reasons for the disappearance of the professor, in which intrigues in the academic world are intermingled with sinister activities of the Turkish Mafia in Germany."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Javier Piqueras de Noriega, Len Forster\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Javier Piqueras de Noriega is a professor of physics in the University Complutense of Madrid and author of five published novels in Spanish.  Four of his novels can be described as “academic thrillers”:"), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0